module.exports = __webpack_public_path__ + "img/3.81e67e32.jpg";